import { useTranslation } from 'react-i18next';

import { StatusBadge, SummaryInformationContent, Utils } from '@treezor/design-system';

import { IWallet } from '../store';
import { useUserWallet } from '../hooks/useUserWallet';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useI18nLocale } from '@/hooks/useI18nLocale';

import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { IUser } from '@/features/user/store/user.model';

import { WalletMenu } from '@/features/wallets/components/WalletMenu';
import { WalletStarred } from '@/features/wallets/components/WalletStarred';

export interface IWalletProps {
  wallet: IWallet;
  user: IUser;
}

export const Wallet = ({ wallet, user }: IWalletProps) => {
  const { t } = useTranslation();
  const { hasAccessToFeature } = useAccesControl();
  const locale = useI18nLocale();

  const { statusProps, isLoading, onChangeFavorite, isStarred } = useUserWallet({
    user,
    wallet,
  });

  return (
    <div className="flex flex-col gap-3 w-full">
      <StatusBadge emphasis="low" size="s" className="w-fit" {...statusProps} />
      <div>
        <h6 className="typo-h6-bold text-secondary">{wallet.eventName || '-'}</h6>
        <span className="typo-body-regular-small text-tertiary mt-1">{`ID #${wallet.walletId}`}</span>
      </div>
      <div className="flex flex-col">
        <SummaryInformationContent
          label={t('pages.currentProfiles.wallets.wallet.solde')}
          value={Utils.currencyFormater(locale, Number(wallet.solde), 'EUR')}
        />
        <SummaryInformationContent
          label={t('pages.currentProfiles.wallets.wallet.authorizedBalance')}
          value={Utils.currencyFormater(locale, Number(wallet.authorizedBalance), 'EUR')}
        />
      </div>
      <div className="flex items-center justify-between">
        <span className="typo-body-regular-small text-secondary">{wallet.iban || '-'}</span>
        <div className="flex items-center">
          <WalletStarred isLoading={isLoading} isStarred={isStarred} onClick={onChangeFavorite} />
          {hasAccessToFeature(featuresSlugs.PROFILES_BOARD) &&
            hasAccessToFeature(
              [
                featuresSlugs.WALLET_DETAILS,
                featuresSlugs.ACCOUNT_DETAIL,
                featuresSlugs.EDIT_WALLET,
                featuresSlugs.STATEMENT,
                featuresSlugs.DEACTIVATE_WALLET,
                featuresSlugs.BALANCE_CERTIFICATE,
                featuresSlugs.DOMICILIATION_CERTIFICATE,
                featuresSlugs.CLOSURE_CERTIFICATE,
              ],
              'OR',
            ) && <WalletMenu wallet={wallet} user={user} />}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
